import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"

const GernalInfo = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="General Information" midBreadcrumb="Disclosure" mainBreadcrumb="General Information" ></Breadcrumb>
            <div className='inner-page'>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="mainhead">General Information</h2>
                            <div className="tablescroll table-responsive">
                                <table className="table table-bordered">
                                    <tbody>
                                        <tr>
                                            <td>1. </td>
                                            <td width="48%"><strong>Name of the  School and Address</strong>
                                                <p>(i) School Code  </p>
                                                <p>(ii) Email</p>
                                                <p>(iii) Telephone No.</p>
                                                <p>(iv) Fax No.</p>
                                                <p>(v) Social Media Links</p>
                                            </td>
                                            <td width="48%"><strong>Mata Mariam Jan Seva Vidyalaya, Narnaul, Nasibpur, Haryana-123001.</strong>
                                                <p>40274</p>
                                                <p><a href="mailto:matamariamjansevavidyalaya@gmail.com">matamariamjansevavidyalaya@gmail.com</a></p>
                                                <p> 01282-260211, 261052 / Mob : 9050269525</p>
                                                <p>Not Available</p>
                                                <p>FB - @mmjsv, YOUTUBE - MATA MARIAM</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>2.</td>
                                            <td><strong>Year of Establishment of School</strong></td>
                                            <td>1992</td>
                                        </tr>
                                        <tr>
                                            <td>3.</td>
                                            <td><strong>Whether NOC from State/UT or Recommendation of Embassy of India obtained?</strong>
                                                <p>(i) NOC No. State</p>
                                                <p>(ii) NOC Issuing Date</p>
                                            </td>
                                            <td><strong>Haryana</strong><br />
                                                <p>Assistant Sceretary of Education Sec, Haryana</p>
                                                <p>15/01/1998</p>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>4.</td>
                                            <td><strong>Is the school recognized, If yes by which authority?</strong></td>
                                            <td>CBSE Deputy Secretary (Aff.)</td>
                                        </tr>
                                        <tr>
                                            <td>5.</td>
                                            <td><strong>Status of Affiliation</strong></td>
                                            <td>Regular</td>
                                        </tr>
                                        <tr>
                                            <td>6.</td>
                                            <td><strong>Name of Trust/Society/Company Registered Under Section 25 of the Company Act, 1956</strong></td>
                                            <td>Catholic Diocese of Indore, Dated 15/06/1960</td>
                                        </tr>
                                        <tr>
                                            <td>7.</td>
                                            <td><strong>Period up to which Registration of Trust/Society is valid</strong></td>
                                            <td>Permanent</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default GernalInfo